"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_single_element_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const document_1 = require("../../document");
const main_1 = require("../../../main");
const update_single_element_1 = require("../../../../../api/calls/document/update_single_element");
exports.update_single_element_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/update_single_element_thunk", (arg, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { data, newElement } = arg;
    // Only show loading indicator for existing element updates, not new elements
    // This prevents blocking user interaction when placing new elements
    if (!newElement) {
        dispatch((0, document_1.setIsLoading)(true));
    }
    // Add timestamp to track request order
    const requestTimestamp = Date.now();
    // Store the original temp ID so we can replace it after backend responds
    const tempId = (_a = data === null || data === void 0 ? void 0 : data.payload) === null || _a === void 0 ? void 0 : _a._id;
    const isTempId = typeof tempId === "string" && tempId.startsWith("temp_");
    // Check if element already exists in Redux (by ID)
    const state = getState();
    const existingElement = state.documentState.selectedDocumentElements.find((el) => { var _a; return el._id === ((_a = data === null || data === void 0 ? void 0 : data.payload) === null || _a === void 0 ? void 0 : _a._id); });
    // If element exists in Redux (even with temp ID), EDIT it
    // If element doesn't exist, ADD it as new
    if (existingElement) {
        dispatch((0, document_1.editSelectedDocumentElements)(Object.assign(Object.assign({}, data.payload), { _lastUpdateTimestamp: requestTimestamp })));
    }
    else {
        // Add new element to array
        dispatch((0, document_1.updateSelectedDocumentElements)(Object.assign(Object.assign({}, data.payload), { _lastUpdateTimestamp: requestTimestamp })));
    }
    // Pass document status to the API call to use the correct endpoint
    const response = yield (0, update_single_element_1.update_single_element)(Object.assign(Object.assign({}, data), { documentStatus: (_b = state.documentState.selectedDocument) === null || _b === void 0 ? void 0 : _b.status }), false);
    // Only clear loading indicator if we set it (for existing element updates)
    if (!newElement) {
        dispatch((0, document_1.setIsLoading)(false));
    }
    if (response.success) {
        // Check if this response is newer than what's in Redux
        const currentState = getState();
        const currentElement = currentState.documentState.selectedDocumentElements.find((el) => { var _a; return el._id === ((_a = response.content) === null || _a === void 0 ? void 0 : _a._id) || el._id === tempId; });
        const currentTimestamp = (currentElement === null || currentElement === void 0 ? void 0 : currentElement._lastUpdateTimestamp) || 0;
        const isNewer = requestTimestamp >= currentTimestamp;
        // Only apply backend response if it's newer than current Redux state
        if (isNewer) {
            // If element had a temp ID, replace it with backend response
            // Otherwise, update element with real ID
            if (isTempId) {
                dispatch((0, document_1.editSelectedDocumentElementsNullId)({
                    tempId,
                    element: Object.assign(Object.assign({}, response.content), { _lastUpdateTimestamp: requestTimestamp }),
                }));
            }
            else {
                dispatch((0, document_1.editSelectedDocumentElements)(Object.assign(Object.assign({}, response.content), { _lastUpdateTimestamp: requestTimestamp })));
            }
        }
        if (newElement) {
            dispatch((0, document_1.setSelectedElement)(response.content));
            // Auto-select newly placed elements so properties panel shows immediately
            dispatch((0, document_1.setSelectedElementID)(response.content._id));
        }
        return response.content;
    }
    else {
        // Show user feedback for failed saves - data integrity is critical for document signing
        dispatch((0, main_1.setMessageModal)({
            title: "Save Failed",
            messages: [
                response.message || "Your changes could not be saved.",
                "Please try again or refresh the page.",
            ],
        }));
    }
    return null;
}));
